/**
 * Formats an XML string with indentation and newlines for readability.
 *
 * - Inserts newlines between XML tags.
 * - Indents nested tags based on their depth using spaces.
 * - Supports customizable indentation size and newline characters.
 *
 * @param {string} xmlInput - The raw XML string to format.
 * @param {Object} [options] - Optional settings.
 * @param {number} [options.indent=2] - Number of spaces to use per indentation level.
 * @param {string} [options.newline="\n"] - Newline character(s) to use.
 * @returns {string} The formatted XML string.
 *
 * @example
 * const rawXml = "<root><child>value</child></root>";
 * formatXml(rawXml);
 * // Returns:
 * // "<root>
 * //   <child>value</child>
 * // </root>"
 *
 * @example
 * formatXml(rawXml, { indent: 4, newline: "\r\n" });
 * // Uses 4 spaces for indentation and Windows-style newlines.
 */
function formatXml(xmlInput, options = {}) {
  const stringTimesN = (n, char) => Array(n + 1).join(char)

  const {
    indent: indentOption = 2,
    newline: newlineOption = `
`,
  } = options
  const indentString = stringTimesN(indentOption, " ")

  let formatted = ""
  const regex = /(>)(<)(\/*)/g
  const xml = xmlInput.replace(regex, `$1${newlineOption}$2$3`)
  let pad = 0
  xml.split(/\r?\n/).forEach(l => {
    const line = l.trim()

    let indent = 0
    if (line.match(/.+<\/\w[^>]*>$/)) {
      indent = 0
    } else if (line.match(/^<\/\w/)) {
      if (pad !== 0) pad -= 1
    } else if (line.match(/^<\w([^>]*[^/])?>.*$/)) {
      indent = 1
    } else {
      indent = 0
    }

    const padding = stringTimesN(pad, indentString)
    formatted += padding + line + newlineOption
    pad += indent
  })

  return formatted.trim()
}

export { formatXml }
